import { useMemo } from 'react';
import { useCurrentUser } from 'hooks/users/queries';

const useCoders = (pathname) => {
  const { data: user } = useCurrentUser();
  
  return useMemo(() => {
    const isMeOnly = pathname.includes('user/me');
    return isMeOnly && user?.id ? [user.id] : [];
  }, [pathname, user?.id]);
};

export default useCoders;